import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import ReactApexChart from "react-apexcharts";
import CardHeader from "../shared/CardHeader";
import useCardTitleActions from "../../hooks/useCardTitleActions";
import CardLoader from "../shared/CardLoader";
import { fetchData } from "../../utils/options";
import Swal from "sweetalert2";

const LeadsOverviewChart = ({
  chartHeight = 300,
  isFooterShow = true,
  leadSummary = [],
  chartOptions = { series: [], labels: [] },
  permission = { pf_view: 1 },
}) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const M_id = queryParams.get("id");

  const {
    refreshKey,
    isRemoved,
    isExpanded,
    handleRefresh,
    handleExpand,
    handleDelete,
  } = useCardTitleActions();

  // Guard: If removed or no view permission, don't render the card
  if (isRemoved || permission?.pf_view !== 1) {
    return null;
  }

  return (
    <div className="col-xxl-4">
      <div
        className={`card stretch stretch-full leads-overview ${
          isExpanded ? "card-expand" : ""
        } ${refreshKey ? "card-loading" : ""}`}
      >
        <CardHeader
          title={"Inquiry Overview"}
          refresh={handleRefresh}
          remove={handleDelete}
          expanded={handleExpand}
        />

        <div className="card-body custom-card-action">
          {chartOptions?.series?.length > 0 ? (
            <ReactApexChart
              options={chartOptions}
              series={chartOptions.series}
              type="donut"
              height={chartHeight}
            />
          ) : (
            <p className="text-center">No data available</p>
          )}

          <div className="row g-2 pt-2">
            {(Array.isArray(leadSummary) ? leadSummary : []).length > 0 ? (
              leadSummary.map((val, index) => (
                <div key={index} className="col-4">
                  <Link
                    to="#"
                    className="p-2 hstack gap-2 rounded border border-dashed border-gray-5"
                  >
                    <span
                      className={`wd-7 ht-7 rounded-circle d-inline-block circle-${
                        index + 1
                      }`}
                    ></span>
                    <span>
                      {val?.LeadType || "N/A"}
                      <span className="fs-10 text-muted ms-1">
                        ({val?.TotalLeads ?? 0})
                      </span>
                    </span>
                  </Link>
                </div>
              ))
            ) : (
              <p className="text-center"></p>
            )}
          </div>
        </div>

        {isFooterShow && (
          <div className="card-footer fs-11 fw-bold text-uppercase text-center"></div>
        )}

        <CardLoader refreshKey={refreshKey} />
      </div>
    </div>
  );
};

export default LeadsOverviewChart;
